import React from "react";
import { RestorationProjectType } from "@ecologi/shared";
import { ProjectVisualsType } from "./project-visuals";
import WildflowersIcon from "@ecologi/assets/icons/ProjectInsights/wildflowers.svg";
import WetlandsIcon from "@ecologi/assets/icons/ProjectInsights/wetlands.svg";

const PATH = "/images/app/forest/habitat_restoration/pictograms/";

export const habitatRestorationVisuals: Record<
  RestorationProjectType,
  ProjectVisualsType
> = {
  [RestorationProjectType.Rainforest]: {
    icon: <></>,
    pictogram: "",
  },
  [RestorationProjectType.Wildlife]: {
    icon: <></>,
    pictogram: "",
  },
  [RestorationProjectType.Wetlands]: {
    // Data here is a temporary fix to avoid collision with carbon avoidance wetlands
    // property (see project-visuals.ts)
    icon: <WetlandsIcon />,
    pictogram: "/images/app/forest/carbon_avoidance/pictograms/wetlands.svg",
  },
  [RestorationProjectType.Wildflowers]: {
    icon: <WildflowersIcon />,
    pictogram: `${PATH}wildflowers.svg`,
  },
  [RestorationProjectType.All]: {
    icon: <></>,
    pictogram: "",
  },
  [RestorationProjectType.None]: {
    icon: <></>,
    pictogram: "",
  },
};
